export default __webpack_public_path__ + "static/BAWL-dd2e94bb4f610698b10d20ca38bc47c1.png";